import { render, staticRenderFns } from "./PermissionError.vue?vue&type=template&id=34d2a7b3&"
import script from "./PermissionError.vue?vue&type=script&lang=js&"
export * from "./PermissionError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports